import { render, staticRenderFns } from "./SVGLoader.vue?vue&type=template&id=cd69e71e&scoped=true&"
import script from "./SVGLoader.vue?vue&type=script&lang=js&"
export * from "./SVGLoader.vue?vue&type=script&lang=js&"
import style0 from "./SVGLoader.vue?vue&type=style&index=0&id=cd69e71e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd69e71e",
  null
  
)

export default component.exports